import { render, staticRenderFns } from "./Bigdata.vue?vue&type=template&id=c63fd3ba&scoped=true&"
import script from "./Bigdata.vue?vue&type=script&lang=js&"
export * from "./Bigdata.vue?vue&type=script&lang=js&"
import style0 from "./Bigdata.vue?vue&type=style&index=0&id=c63fd3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63fd3ba",
  null
  
)

export default component.exports